export const defaultParameters = [
  {
    fieldType: "Input",
    type: "date",
    value: "",
    placeholder: "",
    disabled: false,
    title: "Дата рождения Страхователя",
    validation: 'birth_date',
    error: "",
  },
  {
    fieldType: "Select",
    items: [
      {
        key: '0',
        value: 'Мужской',
      },
      {
        key: '1',
        value: 'Женский',
      },
    ],
    value: "",
    placeholder: "Пол страхователя",
    disabled: false,
    title: "Пол страхователя",
    validation: 'sex',
    error: "",
  },
  {
    fieldType: "Input",
    type: "text",
    value: "5 лет",
    placeholder: "",
    disabled: true,
    title: "Срок страхования",
    validation: '',
    error: "",
  },
  {
    fieldType: "Input",
    type: "number",
    value: "",
    placeholder: "Единовременный взнос",
    disabled: false,
    title: "Единовременный взнос",
    validation: 'payment',
    error: "",
  },
  {
    fieldType: "Input",
    type: "text",
    value: "Единовременно",
    placeholder: "",
    disabled: true,
    title: "Порядок оплаты",
    validation: '',
    error: "",
  },
]

export const defaultParameters2 = [
  {
    fieldType: "Input",
    type: "date",
    value: "",
    placeholder: "",
    disabled: false,
    title: "Дата рождения Страхователя",
    validation: 'birth_date',
    error: "",
  },
  {
    fieldType: "Select",
    items: [
      {
        key: '0',
        value: 'Мужской',
      },
      {
        key: '1',
        value: 'Женский',
      },
    ],
    value: "",
    placeholder: "Пол страхователя",
    disabled: false,
    title: "Пол страхователя",
    validation: 'sex',
    error: "",
  },
  {
    fieldType: "Input",
    type: "text",
    value: "1 год",
    placeholder: "",
    disabled: true,
    title: "Срок страхования",
    validation: '',
    error: "",
  },
  {
    fieldType: "Select",
    items: [
      {
        key: '2500',
        value: '2 500 ₽',
      },
      {
        key: '5000',
        value: '5 000 ₽',
      },
      {
        key: '10000',
        value: '10 000 ₽',
      },
    ],
    value: "2500",
    placeholder: "Стоимость полиса",
    disabled: false,
    title: "Стоимость полиса",
    validation: 'payment',
    error: "",
  },
  {
    fieldType: "Input",
    type: "text",
    value: "25 000 ₽",
    placeholder: "",
    disabled: true,
    title: "Страховая сумма",
    validation: '',
    error: "",
  },
]

export const defaultInsurer = [
  {
    fieldType: "Input",
    type: "text",
    value: "",
    placeholder: "Фамилия",
    disabled: false,
    title: "Фамилия",
    validation: 'last_name',
    error: "",
  },
  {
    fieldType: "Input",
    type: "text",
    value: "",
    placeholder: "Имя",
    disabled: false,
    title: "Имя",
    validation: 'first_name',
    error: "",
  },
  {
    fieldType: "Input",
    type: "text",
    value: "",
    placeholder: "Отчество",
    disabled: false,
    title: "Отчество",
    validation: 'middle_name',
    error: "",
  },
  {
    fieldType: "Input",
    type: "date",
    value: "",
    placeholder: "",
    disabled: false,
    title: "Дата рождения",
    validation: 'birth_date',
    error: "",
  },
  {
    fieldType: "Select",
    items: [
      {
        key: '0',
        value: 'Мужской',
      },
      {
        key: '1',
        value: 'Женский',
      },
    ],
    value: "",
    placeholder: "Пол",
    disabled: false,
    title: "Пол",
    validation: 'sex',
    error: "",
  },
  {
    fieldType: "Input",
    type: "text",
    value: "",
    placeholder: "Место рождения",
    disabled: false,
    title: "Место рождения",
    validation: 'birth_place',
    error: "",
  },
  {
    fieldType: "Input",
    type: "text",
    value: "РФ",
    placeholder: "",
    disabled: true,
    title: "Гражданство",
    validation: 'citizenship',
    error: "",
  },
  {
    fieldType: "Input",
    type: "tel",
    value: "",
    placeholder: "Телефон",
    disabled: false,
    title: "Телефон",
    mask: 'tel',
    validation: 'phone',
    error: "",
  },
  {
    fieldType: "Input",
    type: "email",
    value: "",
    placeholder: "Электронная почта",
    disabled: false,
    title: "E-mail",
    validation: 'email',
    error: "",
  },
]

export const defaultDocuments = [
  {
    fieldType: "Input",
    fieldName: "type",
    type: "text",
    value: "Паспорт РФ",
    placeholder: "",
    disabled: true,
    title: "Тип документа",
    validation: '',
    error: "",
  },
  {
    fieldType: "Input",
    fieldName: "serial",
    type: "text",
    value: "",
    placeholder: "Серия",
    disabled: false,
    title: "Серия",
    mask: 'passport-serial',
    validation: 'passport_serial',
    error: "",
  },
  {
    fieldType: "Input",
    fieldName: "number",
    type: "text",
    value: "",
    placeholder: "Номер",
    disabled: false,
    title: "Номер",
    mask: 'passport-number',
    validation: 'passport_number',
    error: "",
  },
  {
    fieldType: "Input",
    fieldName: "date",
    type: "date",
    value: "",
    placeholder: "",
    disabled: false,
    title: "Дата выдачи",
    validation: 'passport_date',
    error: "",
  },
  {
    fieldType: "Input",
    fieldName: "auth_code",
    type: "text",
    value: "",
    placeholder: "Код подразделения",
    disabled: false,
    title: "Код подразделения",
    mask: 'passport-code',
    validation: 'passport_code',
    error: "",
  },
  {
    fieldType: "Input",
    fieldName: "auth",
    type: "text",
    value: "",
    placeholder: "Кем выдан",
    disabled: false,
    title: "Кем выдан",
    validation: 'passport_given',
    error: "",
  },
]

export const defaultAddress = [
  {
    fieldType: "Input",
    type: "text",
    value: "",
    placeholder: "Индекс",
    disabled: false,
    title: "Индекс",
    mask: 'passport-number',
    validation: 'index',
    error: "",
  },
  {
    fieldType: "Autocomplete",
    items: [],
    value: "",
    placeholder: "НП/Город",
    disabled: false,
    title: "НП/Город",
    validation: 'city',
    error: "",
  },
  {
    fieldType: "Autocomplete",
    items: [],
    value: "",
    placeholder: "Улица",
    disabled: false,
    title: "Улица",
    validation: 'street',
    error: "",
  },
  {
    fieldType: "Input",
    type: "text",
    value: "",
    placeholder: "Дом",
    disabled: false,
    title: "Дом",
    validation: 'house',
    error: "",
  },
  {
    fieldType: "Input",
    type: "text",
    value: "",
    placeholder: "Корпус",
    disabled: false,
    title: "Корпус",
    validation: 'housing',
    error: "",
  },
  {
    fieldType: "Input",
    type: "text",
    value: "",
    placeholder: "Строение",
    disabled: false,
    title: "Строение",
    validation: 'building',
    error: "",
  },
  {
    fieldType: "Input",
    type: "text",
    value: "",
    placeholder: "Квартира",
    disabled: false,
    title: "Квартира",
    validation: 'apartment',
    error: "",
  },
]

export const defaultBeneficiaries = [
  {
    fieldType: "Input",
    fieldName: "last_name",
    type: "text",
    value: "",
    placeholder: "Фамилия",
    disabled: false,
    title: "Фамилия",
    validation: 'last_name',
    error: "",
  },
  {
    fieldType: "Input",
    fieldName: "first_name",
    type: "text",
    value: "",
    placeholder: "Имя",
    disabled: false,
    title: "Имя",
    validation: 'first_name',
    error: "",
  },
  {
    fieldType: "Input",
    fieldName: "middle_name",
    type: "text",
    value: "",
    placeholder: "Отчество",
    disabled: false,
    title: "Отчество",
    validation: 'middle_name',
    error: "",
  },
  {
    fieldType: "Input",
    fieldName: "birth_date",
    type: "date",
    value: "",
    placeholder: "",
    disabled: false,
    title: "Дата рождения",
    validation: 'birth_date',
    error: "",
  },
  {
    fieldType: "Input",
    fieldName: "relationship",
    type: "text",
    value: "",
    placeholder: "Родственные отношения",
    disabled: false,
    title: "Родственные отношения",
    validation: 'relationship',
    error: "",
  },
  {
    fieldType: "Input",
    fieldName: "address",
    type: "text",
    value: "",
    placeholder: "Адрес регистрации",
    disabled: false,
    title: "Адрес регистрации",
    validation: 'address',
    error: "",
  },
  {
    fieldType: "Input",
    fieldName: "part",
    type: "number",
    value: "",
    placeholder: "Доля от страховой суммы, %",
    disabled: false,
    title: "Доля от страховой суммы, %",
    validation: 'procent',
    error: "",
  },
]